module.exports = __webpack_public_path__ + "static/media/VERSA.d07c4012.svg";